import { useEffect, useState } from "react";

export default function Banner() {
    const slides = [
        {
            image: "/jadi_host.png",
        },
        {
            image: "/jadi_reseller.png",
        },
        {
            image: "/nitnot_banner.jpeg",
        },
        {
            image: "/topup_24_jam.png",
        },
    ];
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const goNext = () => setActiveSlide((prev) => (prev + 1) % slides.length);
    const goPrev = () =>
        setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);


    return <>
        <div className="px-4 sm:px-6 lg:px-8">
            <div className="relative w-full aspect-[16/9] md:aspect-[16/7] rounded-2xl overflow-hidden bg-white">
                {slides.map((slide, index) => (
                    <div
                        key={slide.image}
                        className={`absolute inset-0 transition-opacity duration-500 ${activeSlide === index ? "opacity-100" : "opacity-0"
                            }`}
                    >
                        <img src={slide.image} alt="Slide banner" className="size-full object-cover" />
                        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0)_35%,rgba(88,28,135,0.18)_100%)]" />
                    </div>
                ))}

                <button
                    type="button"
                    onClick={goPrev}
                    className="absolute left-3 top-1/2 -translate-y-1/2 z-10 h-10 w-10 rounded-full bg-black/35 text-white hover:bg-black/50"
                    aria-label="Slide sebelumnya"
                >
                    ‹
                </button>
                <button
                    type="button"
                    onClick={goNext}
                    className="absolute right-3 top-1/2 -translate-y-1/2 z-10 h-10 w-10 rounded-full bg-black/35 text-white hover:bg-black/50"
                    aria-label="Slide berikutnya"
                >
                    ›
                </button>

                <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2 flex gap-2">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            type="button"
                            onClick={() => setActiveSlide(index)}
                            className={`h-2.5 w-2.5 rounded-full ${activeSlide === index ? "bg-white" : "bg-white/50"
                                }`}
                            aria-label={`Pergi ke slide ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    </>
}
